import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import localeFr from '@angular/common/locales/fr'

import { AppComponent } from './app.component'
import { LoginModule } from './pages/login/login.module'
import { HomeComponent } from './pages/home/home.component'
import { AppRoutingModule } from './app-routing.module'
import { APP_BASE_HREF, DatePipe, registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { BanniereModule, FooterModule, HvDateAdapter } from '@helvetia/components'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HeaderModule } from './components/header/header.module'
import { SidebarModule } from './components/sidebar/sidebar.module'
import { MaterialImporterModule } from './shared/material-importer/material-importer.module'
import { HomeModule } from './pages/home/home.module'
import { MarketsModule } from './components/markets/markets.module'
import { StatistiquesModule } from './pages/statistiques/statistiques.module'
import { MarketModule } from './components/market/market.module'
import { EditMarketModule } from './components/edit-market/edit-market.module'
import { EditTypeSupportModule } from './components/edit-type-support/edit-type-support.module'
import { RequestInterceptor } from 'src/auth/http_error_interceptor'
import { CustomErrorHandler } from 'src/auth/custom_error_handler'
import { ModalInfoModule } from './components/modal-info/modal-info.module'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { CustomPaginator } from './shared/utils/paginator'
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core'
import { MY_DATE_FORMATS } from './shared/utils/date-format'

registerLocaleData(localeFr, 'fr-FR')

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    BanniereModule,
    FooterModule,
    HeaderModule,
    HttpClientModule,
    SidebarModule,
    MaterialImporterModule,
    LoginModule,
    MarketsModule,
    MarketModule,
    HomeModule,
    EditMarketModule,
    EditTypeSupportModule,
    ModalInfoModule,
    StatistiquesModule
  ],
  providers: [CustomErrorHandler,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: DateAdapter, useClass: HvDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    DatePipe,
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
